import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';
import useIsMobile from 'hooks/useIsMobile';
import CustomButton from 'components/CustomButton';

export default function MainContent() {
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <>
      <Box pb={3} pt={6} bgcolor="#EEEEEE" textAlign="center">
        <Container>
          <Box pb={6}>
            <Typography className={classes.subTitlePurple} variant="h2">
              Benefits of Teams & Labs Subscription
            </Typography>
          </Box>
          <Grid container={true} spacing={4}>
            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/special-price.svg"
                alt="special-price-image"
                loading="lazy"
                width="90"
                height="97"
              />

              <p className={classes.benefitsText}>Special price</p>
              <p className={classes.benefitsPurple}>99 USD MONTHLY</p>
              <p className={classes.benefitsText}>(9.9 USD/user)</p>
            </Grid>

            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/10-simultaneous.svg"
                alt="10-simultaneous-image"
                loading="lazy"
                width="79"
                height="86"
              />

              <p className={classes.benefitsPurple}>
                10 <br /> SIMULTANEOUS
              </p>
              <p className={classes.benefitsText}>users or more</p>
            </Grid>

            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/share-content.svg"
                alt="share-content-image"
                loading="lazy"
                width="75"
                height="84"
              />

              <p className={classes.benefitsText}>
                Share content <br /> among
              </p>
              <p className={classes.benefitsPurple}>TEAM MEMBERS</p>
            </Grid>

            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/50-custom.svg"
                alt="50-custom-image"
                loading="lazy"
                width="67"
                height="86"
              />

              <p className={classes.benefitsPurple}>50 CUSTOM</p>
              <p className={classes.benefitsText}>
                illustrations request <br /> monthly
              </p>
            </Grid>

            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/creations.svg"
                alt="creations-image"
                loading="lazy"
                width="90"
                height="80"
              />
              <p className={classes.benefitsText}>Unlimited</p>
              <p className={classes.benefitsPurple}>CREATIONS</p>
            </Grid>

            <Grid item={true} xs={12} md={4}>
              <img
                src="/images/teams-and-labs/unlimited-scientific.svg"
                alt="unlimited-scientific-image"
                loading="lazy"
                width="86"
                height="88"
              />
              <p className={classes.benefitsText}>Unlimited</p>
              <p className={classes.benefitsPurple}>
                SCIENTIFIC <br /> ILLUSTRATIONS
              </p>
            </Grid>
          </Grid>

          <Box pb={5}>
            <CustomButton
              href="https://content.mindthegraph.com/leaders-custom-service-qualification"
              target="_blank"
            >
              Request a Quote
            </CustomButton>
          </Box>
        </Container>
      </Box>

      <LazyLoad offset={100}>
        <Box py={6} bgcolor="#FFFFFF" textAlign="center">
          <Container>
            <Box pb={4}>
              <Typography className={classes.subTitlePurple} variant="h2">
                Mind the Graph's trusted by researchers and professionals <br /> from 100+
                biotechnology and pharmaceutical companies
              </Typography>
            </Box>

            <Box pl={isMobile ? 0 : 27} pr={isMobile ? 0 : 32}>
              <Grid alignItems="center" justifyContent="space-evenly" container={true}>
                <Grid item={true} sm={12} md={4}>
                  <img
                    src="/images/teams-and-labs/viatris-logo.png"
                    alt="viatris-image"
                    loading="lazy"
                    width="215"
                    height="57"
                  />
                </Grid>

                <Grid item={true} sm={12} md={4}>
                  <img
                    src="/images/teams-and-labs/sanofi-logo.png"
                    alt="sanofi-image"
                    loading="lazy"
                    width="112"
                    height="88"
                  />
                </Grid>

                <Grid item={true} sm={12} md={4}>
                  <img
                    src="/images/teams-and-labs/edanz-logo.png"
                    alt="edanz-image"
                    loading="lazy"
                    width="306"
                    height="97"
                  />
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box py={4} bgcolor="#EEEEEE" textAlign="center">
          <Container>
            <Box pb={4}>
              <Typography className={classes.subTitlePurple} variant="h2">
                Pharmaceutical Brochure
              </Typography>
            </Box>

            <Grid container={true} spacing={2} alignItems="center" justifyContent="center">
              <Grid item={true} xs={12} md={6}>
                <Typography align="left">
                  A Pharmaceutical Brochure is very important to keep a clear communication with{' '}
                  your audience. Such work can easily be used to talk directly to healthcare{' '}
                  professionals, medical doctors, and also to educate patients about diseases or
                  pharmaceutical advertising campaigns. Subscribe to Mind the Graph with a Teams &
                  Labs Plan and start creating your pharmaceutical brochure right now.
                </Typography>

                <Box
                  mt={4}
                  className={classes.btnPharmaceutical}
                  display="flex"
                  justifyContent="start"
                >
                  <CustomButton
                    href="https://content.mindthegraph.com/leaders-custom-service-qualification"
                    target="_blank"
                  >
                    Request a Quote
                  </CustomButton>
                </Box>
              </Grid>
              <Grid item={true} xs={12} md={5}>
                <img
                  src="/images/teams-and-labs/pharmaceutical.svg"
                  alt="pharmaceutical-image"
                  loading="lazy"
                  width={isMobile ? '315' : '462'}
                  height={isMobile ? '190' : '288'}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box className={classes.sectionCheck} textAlign="center" pb={6}>
          <Container>
            <Typography className={classes.titleWhite} variant="h2">
              Check some of our medical and <br /> pharmaceutical infographic designs
            </Typography>

            <Box px={isMobile ? 0 : 20}>
              <Grid container={true} spacing={2} alignItems="center" justifyContent="center">
                <Grid item={true} xs={12} md={4}>
                  <Box pb={4}>
                    <img
                      src="/images/teams-and-labs/patophysiology.webp"
                      alt="patophysiology-image"
                      loading="lazy"
                      width="256"
                      height="230"
                    />
                  </Box>

                  <img
                    src="/images/teams-and-labs/arterial.webp"
                    alt="arterial-image"
                    loading="lazy"
                    width="255"
                    height="103"
                  />
                </Grid>
                <Box mr={2}>
                  <Grid item={true} xs={12} md={4}>
                    <img
                      src="/images/teams-and-labs/shold.webp"
                      alt="shold-image"
                      loading="lazy"
                      width="282"
                      height="500"
                    />
                  </Grid>
                </Box>
                <Grid item={true} xs={12} md={4}>
                  <Box pb={4}>
                    <img
                      src="/images/teams-and-labs/the-effects.webp"
                      alt="the-effects-image"
                      loading="lazy"
                      width="280"
                      height="212"
                    />
                  </Box>

                  <img
                    src="/images/teams-and-labs/routes.webp"
                    alt="routes-image"
                    loading="lazy"
                    width="280"
                    height="167"
                  />
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad offset={100}>
        <Box bgcolor="#5F29CC" textAlign="center" pb={6}>
          <Container>
            <Typography className={classes.titleWhite} variant="h2">
              We are specialized in Visual Communication for <br />
              Pharmaceutical companies, Life Science Researchers and <br />
              Medical Education, all curated by scientists
            </Typography>

            <Button
              className={classes.btnWhite}
              href="https://content.mindthegraph.com/leaders-custom-service-qualification"
              target="_blank"
            >
              Request a Quote
            </Button>
          </Container>
        </Box>
      </LazyLoad>
    </>
  );
}
